import { render, staticRenderFns } from "./MerchantModal.vue?vue&type=template&id=a364df72&"
import script from "./MerchantModal.vue?vue&type=script&lang=js&"
export * from "./MerchantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports